<template>
    <b-navbar variant="faded" type="light">
        <b-navbar-nav v-if="show_home">
            <b-nav-item :to="home_link"><b-icon icon="house-door"></b-icon> Home</b-nav-item>
            <b-nav-text><b-icon icon="chevron-double-right"></b-icon></b-nav-text>
        </b-navbar-nav>
        <b-navbar-nav v-for="( elem, index ) in elements" :key="index">
            <!-- Il v-if="index < elements.length - 1" controlla se siamo prima dell'ultimo elemento della lista -->
            <b-nav-item v-if="index < elements.length - 1" :to="{ name : elem.link }"><b-icon icon="bookmark"></b-icon> {{elem.text}}</b-nav-item>
            <b-nav-item v-else href='#'><b-icon icon="bookmark"></b-icon> {{elem.text}}</b-nav-item>
            <!-- Icona tra un link e l'altro, no mostrata se l'emento è l'ultimo della lista -->
            <b-nav-text v-if="index < elements.length - 1"><b-icon icon="chevron-double-right"></b-icon></b-nav-text>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
export default {
    name: 'PageTagline',
    data () {
        return {}
    },
    computed : {
        /**
         * Torna il link alla home giusta in base al fatto che chi sta naviagando sia
         * un referente aziendale o un utente normale ( prop is_ref_azi_area )
         */
        home_link : function () {
            if ( this.is_ref_azi_area ) {
                return { name : 'home-refazi' };
            } else {
                return { name : 'home' };
            }
        }
    },
    props : {
        /**
        * Array di elementi da mostrare nella tagline.
        * L'ultimo elemento della lista DEVE essere quello relativo alla
        * pagina sul quale ci si trova.
        * Ogni elemento deve avere la forma:
        *
        * { text : 'Preventivo On Demand', link : 'prevondemad' }
        *
        * dove:
        *   - text: è il testo da mostrare per il link
        *   - link: il nome della route da seguire. Per l'ultimo elemento
		*			ad ogni modo il link viene posto come href="#" perchè
		*			l'ulitmo elemento è quello della pagina sul quale ci si trova.
        */
        elements: {
            type: Array,
            default : () => { return [] }
        },
        /**
        * Se false, permette di nascondere il link iniziale alla home che
        * altrimenti viene sempre mostrato.
        */
        show_home: {
            type: Boolean,
            default: true
        },
        /**
         * Se posto a true indica che siamo sulle pagine di backoffice del referente
         * aziendale, quindi come home viene utilizzata quella del refente aziendale
         * e non quella principale.
         */
        is_ref_azi_area: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped></style>